import { BANK_RECEIPT_RETURN_REQUEST, GET_BANK_RECEIPT_RETURNS, CREATE_BANK_RECEIPT_RETURN, UPDATE_BANK_RECEIPT_RETURN,
  DELETE_BANK_RECEIPT_RETURN, BANK_RECEIPT_RETURN_REQUEST_FAILURE, BANK_RECEIPT_RETURN_REQUEST_SUCCESS, GET_BANK_RECEIPT_RETURNS_PAGE } from '../types';

const initialState = {
  bankReceiptReturns: [],
  bankReceiptReturnsPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const bankReceiptReturnReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_RECEIPT_RETURN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_RECEIPT_RETURNS: {
      return {
        ...state,
        bankReceiptReturns: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_BANK_RECEIPT_RETURNS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        bankReceiptReturnsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_BANK_RECEIPT_RETURN: {
      return {
        ...state,
        bankReceiptReturns: [action.payload, ...state.bankReceiptReturns],
        loading: false,
        error: null
      };
    }
    case UPDATE_BANK_RECEIPT_RETURN: {
      const bankReceiptReturnsData = state.bankReceiptReturns.slice(0);
      const uIndex = bankReceiptReturnsData.findIndex((data) => data.id === action.payload.id);
      bankReceiptReturnsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        bankReceiptReturns: [ ...bankReceiptReturnsData ],
        loading: false,
        error: null
      };
    }
    case DELETE_BANK_RECEIPT_RETURN: {
      const bankReceiptReturns = state.bankReceiptReturns?.slice(0);
      const index = bankReceiptReturns.findIndex((data) => data.id === action.id);
      if (index > -1) {
        bankReceiptReturns.splice(index, 1);
      }
      return {
        ...state,
        bankReceiptReturns: [...bankReceiptReturns],
        loading: false,
        error: null
      }
    }
    case BANK_RECEIPT_RETURN_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
    case BANK_RECEIPT_RETURN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankReceiptReturnReducer;